var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.835,
    cy: 12.835,
    r: 12.835,
    fill: "url(#paint0_linear_7022_31154)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 7.74998C14.1665 8.0594 14.0436 8.35614 13.8248 8.57494C13.606 8.79373 13.3093 8.91665 12.9998 8.91665C12.6904 8.91665 12.3937 8.79373 12.1749 8.57494C11.9561 8.35614 11.8332 8.0594 11.8332 7.74998C11.8332 7.44056 11.9561 7.14381 12.1749 6.92502C12.3937 6.70623 12.6904 6.58331 12.9998 6.58331C13.3093 6.58331 13.606 6.70623 13.8248 6.92502C14.0436 7.14381 14.1665 7.44056 14.1665 7.74998ZM10.6665 12.125C10.6665 11.8929 10.7587 11.6704 10.9228 11.5063C11.0869 11.3422 11.3094 11.25 11.5415 11.25H13.2915C13.5236 11.25 13.7461 11.3422 13.9102 11.5063C14.0743 11.6704 14.1665 11.8929 14.1665 12.125V17.0833H15.0415C15.2736 17.0833 15.4961 17.1755 15.6602 17.3396C15.8243 17.5037 15.9165 17.7262 15.9165 17.9583C15.9165 18.1904 15.8243 18.4129 15.6602 18.577C15.4961 18.7411 15.2736 18.8333 15.0415 18.8333H11.5415C11.3094 18.8333 11.0869 18.7411 10.9228 18.577C10.7587 18.4129 10.6665 18.1904 10.6665 17.9583C10.6665 17.7262 10.7587 17.5037 10.9228 17.3396C11.0869 17.1755 11.3094 17.0833 11.5415 17.0833H12.4165V13H11.5415C11.3094 13 11.0869 12.9078 10.9228 12.7437C10.7587 12.5796 10.6665 12.357 10.6665 12.125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7022_31154",
    x1: 2.73716,
    y1: -1.73018,
    x2: 23.3669,
    y2: 20.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillInformation);
export default __webpack_public_path__ + "static/media/fill_information.487d4f48d729001654df6948b7010fdd.svg";
export { ForwardRef as ReactComponent };